import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-group",
  "use": "icon-group-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-group\"><path d=\"M512.192 85.333333v853.333334h-341.333333V85.333333h341.333333m85.333333-85.333333h-512v1024h512z\" p-id=\"24202\" /><path d=\"M597.525333 370.56l256 76.8v491.2h-256V370.56m-85.333333-114.666667v768h426.666667v-640z\" p-id=\"24203\" /><path d=\"M1024 938.666667H0v85.333333h1024v-85.333333z\" p-id=\"24204\" /><path d=\"M426.666667 170.496h-170.666667v85.333333h170.666667v-85.333333z\" p-id=\"24205\" /><path d=\"M426.666667 341.333333h-170.666667v85.333334h170.666667v-85.333334z\" p-id=\"24206\" /><path d=\"M426.666667 512.106667h-170.666667v85.333333h170.666667v-85.333333z\" p-id=\"24207\" /><path d=\"M768 511.829333h-85.333333v255.893334h85.333333V511.829333z\" p-id=\"24208\" /><path d=\"M426.666667 682.496h-170.666667v85.333333h170.666667v-85.333333z\" p-id=\"24209\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/group.svg
// module id = mak+
// module chunks = 51